
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"48","height":"48"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","transform":"translate(1 2)"}},[_c('path',{attrs:{"fill":"#FFF","fill-rule":"nonzero","stroke":"#000","stroke-width":"1.15","d":"M25.2 22.097a10.17 10.17 0 017.228 3.008 10.263 10.263 0 012.997 7.264h0v3.357c0 .911-.368 1.736-.962 2.333a3.264 3.264 0 01-2.32.966h0H3.857c-.906 0-1.726-.37-2.32-.966a3.297 3.297 0 01-.962-2.333h0V32.37c0-2.836 1.145-5.404 2.997-7.264a10.17 10.17 0 017.228-3.008c.95 0 1.68.24 2.5.5 1.166.371 2.495.791 4.7.791 2.207 0 3.538-.42 4.705-.791.82-.26 1.55-.5 2.495-.5zM18 .575a9.658 9.658 0 016.866 2.856 9.747 9.747 0 012.845 6.9 9.747 9.747 0 01-2.845 6.899A9.658 9.658 0 0118 20.086a9.658 9.658 0 01-6.866-2.856 9.747 9.747 0 01-2.845-6.9 9.747 9.747 0 012.845-6.899A9.658 9.658 0 0118 .575z"}}),_c('rect',{attrs:{"width":"21.6","height":"21.6","x":"22.8","y":"21.6","fill":"#5EEA9C","rx":"10.8"}}),_c('path',{attrs:{"fill":"#FFF","fill-rule":"nonzero","d":"M41.28 32.949v1.782c0 .493-.4.892-.891.892h-3.566v3.566c0 .492-.4.891-.892.891H34.15a.891.891 0 01-.892-.891v-3.566h-3.566a.891.891 0 01-.891-.892V32.95c0-.493.4-.892.891-.892h3.566v-3.566c0-.492.4-.891.892-.891h1.782c.493 0 .892.4.892.891v3.566h3.566c.492 0 .891.4.891.892z"}}),_c('rect',{attrs:{"width":"20.45","height":"20.45","x":"24.575","y":"23.375","stroke":"#000","stroke-width":"1.15","rx":"10.225"}})])])
          )
        }
      }
    